module.exports = __webpack_public_path__ + "media/images/athletes/3572-64bec714b0f8c2a4733b3b3724e34daa.png";